import { LocalConfig } from '../../common/constants/localConfig';
import { AppState } from '../../app-state';
import { errorMessageReducer } from '../../common/reducers/errorMessage';
import { invoicesReducer } from '../../common/reducers/invoices';
import { rootSaga } from '../../common/sagas/rootSaga';
import { createBrowserHistory } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { recaptchaReducer } from '../../common/reducers/recaptcha';

export const history = createBrowserHistory();

export const storeFactory = (config: LocalConfig) => {
  const devTools = ((window as any).devToolsExtension)
    ? ((window as any).devToolsExtension)
    : () => { };

  const sagaMiddleware = createSagaMiddleware();

  const createStoreWithMiddleware = compose(
    applyMiddleware(sagaMiddleware)
  )(createStore);

  const store = (createStoreWithMiddleware as any)(combineReducers<AppState>({
    error: errorMessageReducer,
    invoices: invoicesReducer,
    recaptcha: recaptchaReducer,
  }), devTools());

  sagaMiddleware.run(rootSaga);

  return store;
};
